import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { summitGeometry } from './summitgeo.ts';

/** GENERATED by summitwork/gen.mjs while the layout is in flux. */
const GRID = gridMap('Summit', `
  333333333333333333333333333333333333333333333333333333333333
  333.........................................................
  33..........................................................
  3...........................................................
  3.3333333...........FF.........FF...........................
  3...................FF.........FF...........................
  3..RRRR........................................e............
  3..RRRR.....................................................
  3..RRRR.....FF..........................uuuuuuuuuuu..uuuu...
  3..RRRR.....FF..........................u.uuuuu.........u...
  3..RRRR...................c.............u.uuuuui........u...
  3.......................................u.uuuuu......zzzu...
  3.3333333uuuu..uu.........................uuuuu......zzzu...
  3.......u2.....1u....................................zzzu...
  3.......u2......u...........l...............................
  3.......u2..22..u.......................u.......c...........
  3.......u.......u.......................uzz.................
  3.......ua......u.......................uzz.............u...
  3.......uuu..uuuu.......................uuuuuuu...uuuuuuu...
  3.............................................l.............
  3...........c.....................................3.........
  3.................................................3.........
  3.................................333333..........3.........
  3.........................................FF................
  3.....FF................FF............b...FF................
  3.....FF................FF..................................
  3.............33333.........................3...............
  3...........................................3...............
  3.........................3.................3...............
  3.........................3.................3...............
  3.........................3.................3...............
  3.........................3........l...........33333........
  3........lc.................................................
  3...........uuuu...............uuuu.........................
  3...........................................................
  3........p..................................................
  3...................3.p...........p.........................
  3.......................u...................................
  3.......................u.............FF....................
  3......FF...............u.............FF....................
  3......FF...............u.....c.............................
  3...........................................................
  3....uuuuuuu..uu..uuuuuuuuuuu..uuuuuuuuu....................
  3....u.....u..u.....ub.................u....................
  3....u.....u..u.....ub.................u...FF.............33
  3....u.................................u...FF.............33
  3....u..................222222222222........................
  3....u.....u..u.....u.......................................
  3....u.....u..u.....u...............22.u....................
  3....uu..uuu..u.....u...............22.u....................
  3....u.....u..u.....u..................u....................
  3....u.....u..uuuuuuuuuuuuuu...uuuuuuuuu.l..................
  3....u........u.....u.22222...........lu....................
  3....u........u.2...u...l...................................
  3....u.....u..u.2...u.....u......u..c....c3.................
  3....u.....u........u..................u..3.................
  3....uuuuuuu........u...............2..u..3.................
  3....u.....u..u.....u...............2..u.l3.................
  3....u.....u..u....mu111............2..u....................
  3.............u.....u111....................................
  3.............uu..uuu111.....A.......m......................
  3....u.....u..u.....u111....................................
  3....u.....u..u.....u111............2..u....................
  3....uuuuuuu..u.....u...............2..u.l..................
  3....u.....u........u...............2..u..3.................
  3....u.....u........u..................u..3.................
  3....u........u.....uc....u......u.......c3.................
  3....u........u.....u...l.............l...3.................
  3....u.....u..u.....u............22222.u....................
  3....u.....u..uuuuuuuuuuuuuu..uuuuuuuuuu....................
  3....uu..uuu..u.....u..................u....................
  3....u.....u..u.....u............22222.u...FF...............
  3....u.....u..u.....u.22222222.........u...FF...............
  3....u..............................e.......................
  3....u....................................................33
  3....u.....u..u.....u............22222.u..................33
  3....u.....u..u.....u..................u....................
  3....uuuuuuu..uu..uuuuuu...uuuuuuuuuuuuu....................
  3...........................................................
  3...........................................................
  3.......FF..........l.......................................
  3.......FF....................................uuuuuuuuu.....
  3.............................333333..........u...c...u.....
  3.....................................................u.....
  3...........................................................
  3.............................................u.............
  3..............c....3.........................u.......u.....
  3...................3.........................uuuuuuuuu.....
  3...................3.......................................
  3...................3.......................................
  3...................3.......................................
  3...........................................................
  3.......................c..........FF.......................
  3..................................FF.......................
  3.............3................l......3.....................
  3.............3.......................3.....................
  3.............3.............33333.....3.................333.
  3...l.........3.......................3.....................
  3.....................................3.....................
  3...........................................................
  3....uuuuuuuuuuuu..uuuuuuuu...FF....bb......................
  3....um.....u......2222222u...FF....b.......................
  3....u......u.............u.........................l.......
  3....u......u..........zz.u.................................
  3....u......u..........zz.u.................................
  3....uuuu..uu.............u.................................
  3....u....................u.......c.........................
  3....u.c..................u.................................
  3....u................g.....................................
  3....u...FF.................................................
  3........FF.................................................
  3.........................u.................................
  3....u........o......2....u.......FF........................
  3....uzzz............2...bu.......FF........................
  3....uzzz............2...bu.................................
  3....uuuuuuuuuu.....uuuuuuu.................................
  3...........................................................
  3...........................................................
  3...........................................................
  333333333333333333333333333333333333333333333333333333333333
`, 'summit');

const geo = summitGeometry(GRID);
export const SUMMIT = withGeometry(withGeometry(GRID, { polys: geo.centre, twin: false }), { polys: geo.polys, doors: geo.doors, roofs: geo.roofs });
